<template>
  <div class="mc-widget-call-broadcast__item-connecting-wrapper">
    <div>
      <h4 class="mc-widget-call-broadcast__licenseplate">{{ licensePlate }}</h4>
      <p class="mc-widget-call-broadcast__driver">{{ driver ?? $t('global.text.noDriver') }}</p>
    </div>
    <div class="mc-widget-call-broadcast__state-title-wrapper">
      <p class="mc-widget-call-broadcast__state-title">{{ $t('trackVideo.connecting') + '...' }}</p>
      <i class="mc-fa icon-fill_close" @click="$emit('endBroadcast')" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'StateConnecting',
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      required: true,
      validator: (value) => typeof value === 'string' || value === null,
    },
  },
}
</script>
<style lang="scss">
.mc-widget-call-broadcast__item-connecting-wrapper {
  display: flex;
  align-items: start;
  justify-content: space-between;
}
</style>
